import relatedArticles from './related-articles';

export const RELATED_ARTICLES = {
  entityName: 'mortgages_home_improvement_related_articles',
  sectionName: 'mortgages_home_improvement_related_articles',
  sectionPosition: 4,
  articles: relatedArticles,
};
